var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9993 6.42871C19.7294 6.42871 23.5706 10.2699 23.5706 15C23.5706 19.7301 19.7294 23.5712 14.9993 23.5712C10.2692 23.5712 6.42808 19.7301 6.42808 15C6.42808 10.2699 10.2692 6.42871 14.9993 6.42871ZM14.9993 7.85705C11.0565 7.85705 7.85641 11.0572 7.85641 15C7.85641 18.9427 11.0565 22.1429 14.9993 22.1429C18.9421 22.1429 22.1422 18.9427 22.1422 15C22.1422 11.0572 18.9421 7.85705 14.9993 7.85705Z",
    fill: "white",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7138 0.714474V3.57176C15.7138 3.96604 15.3936 4.28623 14.9993 4.28623C14.6051 4.28623 14.2849 3.96604 14.2849 3.57176V0.714474C14.2849 0.320197 14.6051 0 14.9993 0C15.3936 0 15.7138 0.320197 15.7138 0.714474Z",
    fill: "white",
    fillOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2845 15.7141H26.4273C26.033 15.7141 25.7128 15.3939 25.7128 14.9996C25.7128 14.6054 26.033 14.2852 26.4273 14.2852H29.2845C29.6788 14.2852 29.999 14.6054 29.999 14.9996C29.999 15.3939 29.6788 15.7141 29.2845 15.7141Z",
    fill: "white",
    fillOpacity: 13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5961 25.6069L22.5745 23.5853C22.2959 23.3068 22.2959 22.8537 22.5745 22.5751C22.8531 22.2966 23.3061 22.2966 23.5847 22.5751L25.6063 24.5967C25.8848 24.8753 25.8848 25.3265 25.6063 25.6069C25.3265 25.8855 24.8746 25.8855 24.5961 25.6069Z",
    fill: "white",
    fillOpacity: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39249 24.5967L6.41407 22.5751C6.69264 22.2966 7.14569 22.2966 7.42425 22.5751C7.70282 22.8537 7.70282 23.3068 7.42425 23.5853L5.40267 25.6069C5.1241 25.8855 4.67289 25.8855 4.39249 25.6069C4.11392 25.3271 4.11392 24.8753 4.39249 24.5967Z",
    fill: "white",
    fillOpacity: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2849 29.2846V26.4274C14.2849 26.0331 14.6051 25.7129 14.9993 25.7129C15.3936 25.7129 15.7138 26.0331 15.7138 26.4274V29.2846C15.7138 29.6789 15.3936 29.9991 14.9993 29.9991C14.6051 29.9991 14.2849 29.6789 14.2849 29.2846Z",
    fill: "white",
    fillOpacity: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5708 15.7141H0.713521C0.319244 15.7141 -0.000954151 15.3939 -0.000954151 14.9996C-0.000954151 14.6054 0.319244 14.2852 0.713521 14.2852H3.5708C3.96508 14.2852 4.28528 14.6054 4.28528 14.9996C4.28528 15.3939 3.96508 15.7141 3.5708 15.7141Z",
    fill: "white",
    fillOpacity: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41407 7.42429L4.39249 5.4027C4.11392 5.12413 4.11392 4.67292 4.39249 4.39252C4.67228 4.11395 5.1241 4.11395 5.40267 4.39252L7.42425 6.41411C7.70282 6.69267 7.70282 7.14511 7.42425 7.42429C7.14569 7.70347 6.69264 7.70285 6.41407 7.42429Z",
    fill: "white",
    fillOpacity: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5751 6.41411L24.5967 4.39252C24.8753 4.11395 25.3265 4.11395 25.6069 4.39252C25.8854 4.67231 25.8854 5.12352 25.6069 5.4027L23.5853 7.42429C23.3067 7.70285 22.8537 7.70285 22.5751 7.42429C22.2965 7.14572 22.2965 6.69328 22.5751 6.41411Z",
    fill: "white",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/dark-mode-icon.ab637bb4b26c7960726f8f98d70493bf.svg";
export { ForwardRef as ReactComponent };